import { useEffect, useState } from 'react';

export default function StickyNav() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'nav-scrolled' : 'bg-transparent'
      }`}
    >
      <div className="max-w-6xl mx-auto px-5 lg:px-10 h-14 flex items-center justify-between">
        {/* Logo */}
        <a href="/" className="flex items-center gap-2 cursor-pointer">
          <div className="w-7 h-7 flex items-center justify-center bg-brand-accent rounded-sm">
            <span className="font-bebas text-brand-bg text-sm leading-none tracking-wider">AE</span>
          </div>
          <span className="font-bebas text-brand-text text-lg tracking-widest">
            APEX<span className="text-brand-accent">EMERALD</span>AI
          </span>
        </a>

        {/* CTA Pill — min-h-[44px] for iOS touch target compliance */}
        <a
          href="https://apex-emerald-ai.com/contact"
          className="whitespace-nowrap bg-brand-accent text-brand-bg font-dm font-bold text-sm px-4 rounded-full cursor-pointer hover:brightness-110 transition-all duration-200 border-glow-accent flex items-center min-h-[44px]"
          style={{ boxShadow: '0 0 12px rgba(170,255,69,0.35)' }}
        >
          Try It Free →
        </a>
      </div>
    </header>
  );
}
